module.exports = __webpack_public_path__ + "img/chariot.372c5662.png";